// extracted by mini-css-extract-plugin
export default {"outerDiv":"test_outerDiv__g73jJ","innerDiv":"test_innerDiv__G-zmD"};